import { hot } from 'react-hot-loader/root'; //als eerste

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import PageHeader from "./layout/PageHeader";
import PageContent from "./layout/PageContent";
import ExceptionPage from "./exception/ExceptionPage";

import SideNav from "./layout/SideNav";
import SideNavFinancieel from "./layout/SideNavFinancieel";
import Beads from "./layout/Beads";

import { DomainScopes } from "../constants/DomainConstants";

class App extends React.Component {
	constructor(props, context) {
		super(props, context);
	}

	render() {
		const { showTopNav, showSideNav, showSideNavFinancieel, showBeads, loading, pageHeaderTitle, pageHeaderSubtitle, pageHeaderIntro, exception, topNavTabSettings, domainScope, disableTopNav } = this.props;
		return (
			<div>
				<PageHeader loading={loading} showTopNav={showTopNav} title={pageHeaderTitle} subtitle={pageHeaderSubtitle} intro={pageHeaderIntro}
					topNavTabSettings={topNavTabSettings} scope={domainScope} disableTopNav={disableTopNav} />
				<PageContent id="modal-holder">
					{showSideNav ? <SideNav /> : null}
					{showSideNavFinancieel ? <SideNavFinancieel /> : null}
					{showBeads ? <Beads /> : null}
					{exception ? <ExceptionPage exception={exception} /> : this.props.children}
				</PageContent>

				<div id="modal-holder"/>
			</div>
		);
	}
}

App.propTypes = {
	children: PropTypes.object.isRequired,
	loading: PropTypes.bool.isRequired,
	showTopNav: PropTypes.bool.isRequired,
	pageHeaderSubtitle: PropTypes.string,
	topNavTabSettings: PropTypes.object.isRequired,
	showSideNav: PropTypes.bool.isRequired,
	showSideNavFinancieel: PropTypes.bool.isRequired,
	showBeads: PropTypes.bool,
	pageHeaderTitle: PropTypes.string,
	pageHeaderIntro: PropTypes.string,
	exception: PropTypes.object,
	domainScope: PropTypes.string.isRequired,
	disableTopNav: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
	return {
		loading: state.ajaxCounter > 0,
		showTopNav: state.layout.showTopNav,
		pageHeaderTitle: state.layout.pageHeaderTitle,
		pageHeaderSubtitle: state.layout.pageHeaderSubtitle,
		pageHeaderIntro: state.layout.pageHeaderIntro,
		topNavTabSettings: state.layout.showVoortgangsrapportLayout ? state.layout.voortgangsrapportTopNavTabSettings : state.layout.topNavTabSettings,
		showSideNav: state.layout.showSideNav,
		showSideNavFinancieel: state.layout.showSideNavFinancieel,
		showBeads: state.layout.showBeads && (state.mijnDossier ? !state.mijnDossier.isSchaduwDossier : true),
		exception: state.exception,
		domainScope: state.layout.showVoortgangsrapportLayout ? DomainScopes.VOORTGANGSRAPPORT : DomainScopes.DOSSIERINFRASTRUCTUUR,
		disableTopNav: state.layout.disableTopNav
	};
}

export default hot(connect(mapStateToProps)(App));

